import { PropsWithChildren } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { useDidUpdate, usePreservedCallback } from '@toss/react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { useDialog } from '@zep/dialog';
import { CountryCode } from '@zep/types';
import { Button } from '@zep/ui';
import { PostBillingCardCallBack } from '../../../../services';
import { PaypleProvider, PaypleWidgetDefaultPayload, usePayple } from '../hooks';
import { InputCardNameModal } from '../paymentForm';
import { makeRedirectUrl } from '../subscriptionUtil';
const _PaypleChangePaymentButton = (props: PropsWithChildren<{
  spaceHashId: string;
}>) => {
  const {
    t
  } = useTranslation(['subscription']);
  const router = useRouter();
  const {
    user
  } = useAuth();
  const dialog = useDialog();
  const {
    showWidget,
    isFailure,
    isSuccess,
    failMessage
  } = usePayple();
  const inputCardNameModal = useModal(InputCardNameModal);
  const onSuccessRegisterBilling = usePreservedCallback(() => {
    inputCardNameModal.show({
      spaceHashId: props.spaceHashId,
      onSuccess() {
        inputCardNameModal.remove();
        router.reload();
      }
    });
  });
  const onFailRegisterBilling = usePreservedCallback((message: string) => {
    dialog.alert({
      title: t('subscription:SpaceDetail.changeCardModal.description'),
      content: t('subscription:SpaceDetail.changeCardModal.reason', {
        message: message ?? 'Processing Failure'
      })
    });
  });
  useDidUpdate(() => {
    if (isSuccess) {
      onSuccessRegisterBilling();
    }
  }, [isSuccess, onSuccessRegisterBilling]);
  useDidUpdate(() => {
    if (isFailure) {
      onFailRegisterBilling(failMessage);
      return;
    }
  }, [isFailure, failMessage, onFailRegisterBilling]);
  return <Button variant={'sub'} size={'xs'} onClick={() => showWidget({
    ...PaypleWidgetDefaultPayload,
    type: 'subscription',
    spaceHashId: props.spaceHashId,
    callbackUrl: PostBillingCardCallBack,
    // @ts-ignore
    playerEmail: user.snsId,
    failRedirectUrl: makeRedirectUrl(router, {
      isBillingRegister: false
    }),
    successRedirectUrl: makeRedirectUrl(router, {
      isBillingRegister: true
    })
  })} data-sentry-element="Button" data-sentry-component="_PaypleChangePaymentButton" data-sentry-source-file="PaypleChangePaymentButton.tsx">
      {props.children}
    </Button>;
};
export const PaypleChangePaymentButton = (props: PropsWithChildren<{
  isUpdated: boolean;
  spaceHashId: string;
  countryCode: CountryCode;
}>) => {
  return <PaypleProvider data-sentry-element="PaypleProvider" data-sentry-component="PaypleChangePaymentButton" data-sentry-source-file="PaypleChangePaymentButton.tsx">
      <_PaypleChangePaymentButton spaceHashId={props.spaceHashId} data-sentry-element="_PaypleChangePaymentButton" data-sentry-source-file="PaypleChangePaymentButton.tsx">
        {props.children}
      </_PaypleChangePaymentButton>
    </PaypleProvider>;
};